import { createFileRoute } from '@tanstack/react-router';

import { UploadSuccessPage } from './UploadSuccessPage';

export const Route = createFileRoute('/_protected/_consumer/upload-success/')({
  component: UploadSuccessPage,
});
